import type { PropsWithChildren } from "react";

import { MoreOutlined } from "@ant-design/icons";
import { Button, Popover } from "antd";
import { useTranslation } from "react-i18next";

import { AppLoading } from "@/ui/app-loading";

import { useListTableRowActionsContext } from "./list-table-row-actions.context";

const ListTableRowActions = ({
  isDeleting,
  children,
}: PropsWithChildren<{ isDeleting: boolean }>) => {
  const { isOpen, setOpen } = useListTableRowActionsContext();
  const { t } = useTranslation();

  if (isDeleting) {
    return (
      <AppLoading
        size="small"
        title={t("global:pendingDeletion")}
        className="list-table-row-actions-loading"
      />
    );
  }

  return (
    <Popover
      open={isOpen}
      onOpenChange={setOpen}
      content={children}
      trigger="click"
      placement="bottomRight"
    >
      <Button shape="circle" type="text" icon={<MoreOutlined />} />
    </Popover>
  );
};

export default ListTableRowActions;
